import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://skyagent-artifacts.skywork.ai/page/g4fx3zsin9/images/Capture%20d'/xE9cran5870.png" 
                alt="Logo JS Concept" 
                className="h-8 w-auto"
              />
            </div>
            <p className="text-sm opacity-80">
              Votre partenaire de confiance pour tous vos travaux de peinture et décoration 
              dans le Bas-Rhin.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm opacity-80">
              <div className="flex items-center space-x-2">
                <MapPin className="h-4 w-4" />
                <span>5 Rue des peupliers, 67240 Gries</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="h-4 w-4" />
                <a href="tel:0658864706" className="hover:text-secondary transition-colors">
                  06 58 86 47 06
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="h-4 w-4" />
                <a href="mailto:js.concept@orange.fr" className="hover:text-secondary transition-colors">
                  js.concept@orange.fr
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm opacity-80">
              <li><Link to="/services" className="hover:text-secondary transition-colors">Peinture intérieure</Link></li>
              <li><Link to="/services" className="hover:text-secondary transition-colors">Peinture extérieure</Link></li>
              <li><Link to="/services" className="hover:text-secondary transition-colors">Ravalement de façades</Link></li>
              <li><Link to="/services" className="hover:text-secondary transition-colors">Pose de plafonds</Link></li>
              <li><Link to="/services" className="hover:text-secondary transition-colors">Revêtements muraux</Link></li>
            </ul>
          </div>
        </div>

        {/* Social Media & Copyright */}
        <div className="border-t border-white/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex space-x-4 mb-4 md:mb-0">
              <a 
                href="https://www.instagram.com/js.concept67" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-background hover:text-secondary transition-colors"
              >
                <Instagram className="h-6 w-6" />
              </a>
              <a 
                href="https://www.facebook.com/share/1EnwVSLwQz/?mibextid=wwXIfr"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-background hover:text-secondary transition-colors"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
            <p className="text-sm opacity-60">© 2024 JS Concept. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;